import { inject } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivateFn, Router } from '@angular/router';
import { validate as isUuid } from 'uuid';

/**
 * Guard that validates the conversation route parameters:
 * - Ensures the 'id' route parameter is a valid positive number (chat ID).
 * - If present, ensures the 'assistantUuid' query parameter is a valid UUID.
 * Redirects to the not-found page if any parameter is invalid.
 */
export const conversationCanActivateGuard: CanActivateFn = (
  route: ActivatedRouteSnapshot,
  // eslint-disable-next-line sonarjs/function-return-type
) => {
  const router = inject(Router);

  const routeParamId = route.params['id'] as unknown;
  const chatId = routeParamId ? Number(routeParamId) : null;

  if (routeParamId && (!chatId || !Number.isFinite(chatId) || chatId <= 0)) {
    return router.parseUrl('/not-found');
  }

  const routeQueryAssistantUuid = route.queryParams['assistantUuid'] as unknown;
  const assistantUuid =
    routeQueryAssistantUuid && typeof routeQueryAssistantUuid === 'string'
      ? routeQueryAssistantUuid
      : null;

  if (assistantUuid && !isUuid(assistantUuid)) {
    return router.parseUrl('/not-found');
  }

  return true;
};
